"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3226],{

/***/ 49474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(633);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25989);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81668);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Dropdown = (_a) => {
  var _b = _a, {
    children,
    menu,
    placement = "auto",
    showArrow = false,
    trigger = "hover"
  } = _b, rest = __objRest(_b, [
    "children",
    "menu",
    "placement",
    "showArrow",
    "trigger"
  ]);
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    function handleClickOutside(event) {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [elementRef, show]);
  const { styles, attributes } = (0,react_popper__WEBPACK_IMPORTED_MODULE_1__/* .usePopper */ .D)(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 4]
        }
      }
    ]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onMouseEnter: () => trigger === "hover" && setShow(true),
    onClick: () => {
      trigger === "click" && setShow(!show);
    },
    onMouseLeave: () => trigger === "hover" && setShow(false)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: elementRef
  }, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownMenu, __spreadValues(__spreadValues({
    show,
    ref: tooltipRef,
    style: __spreadProps(__spreadValues({}, styles.popper), { zIndex: 100 })
  }, attributes.popper), rest), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledArrow, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    "data-placement": placement,
    className: (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .getArrowClassName */ .C)(attributes) || ""
  }), menu));
};
const DropdownMenu = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].span`
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
  background-color: white;
  padding: 4px;
  border-radius: 4px;
  visibility: ${(props) => props.show ? "visible" : "hidden"};
  transition: visibility 0.3s;
`;
const StyledArrow = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  &:after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    background-color: white;
    transform: rotate(45deg);
  }
  &.arrow-bottom {
    bottom: 3px;
  }
  &.arrow-top {
    top: -3px;
  }
  &.arrow-left {
    left: -3px;
  }
  &.arrow-right {
    right: 3px;
  }
`;




/***/ }),

/***/ 85104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ FacebookMessengerFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const FacebookMessengerFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 11.331C3 6.72975 6.9885 3 11.9093 3C16.83 3 20.8185 6.72975 20.8185 11.331C20.8185 15.9323 16.83 19.662 11.9093 19.662C11.0198 19.662 10.161 19.5405 9.35025 19.3132L6.30975 21V17.811C4.29075 16.284 3 13.9485 3 11.331ZM10.5435 11.778L12.8475 14.172L17.7128 9.009L13.275 11.463L10.971 9.069L6.10575 14.232L10.5435 11.778Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 34667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ ShoppingCartFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const ShoppingCartFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.5 4.25a.75.75 0 0 1 .75-.75h.558c.95 0 1.52.639 1.845 1.233.217.396.374.855.497 1.271A1.29 1.29 0 0 1 6.25 6h12.498c.83 0 1.43.794 1.202 1.593l-1.828 6.409a2.75 2.75 0 0 1-2.644 1.996H9.53a2.75 2.75 0 0 1-2.652-2.022l-.76-2.772-1.26-4.248-.001-.008c-.156-.567-.302-1.098-.52-1.494C4.128 5.069 3.96 5 3.809 5H3.25a.75.75 0 0 1-.75-.75ZM9 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
          fill: "currentColor"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 95517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ZaloFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const ZaloFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "currentColor" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1 11.1823C1 5.55858 5.92449 1 12 1C18.0755 1 23 5.55858 23 11.1823C23 16.8061 18.0755 21.3647 12 21.3647C10.9018 21.3647 9.84149 21.2162 8.84047 20.9384L5.08646 23V19.1023C2.59365 17.236 1 14.3815 1 11.1823ZM12.5006 9.73507C12.2678 9.78005 12.1258 9.9431 11.9895 10.1174C11.2795 9.50456 10.4957 9.4652 9.72329 9.92061C8.79183 10.4604 8.44538 11.3374 8.56465 12.3663C8.67824 13.3165 9.09285 14.098 10.1038 14.4241C10.7343 14.6265 11.3193 14.5534 11.8361 14.1374C11.9724 14.0305 12.0122 14.053 12.1087 14.1711C12.2962 14.4129 12.6199 14.4972 12.9039 14.3904C13.1822 14.306 13.3753 14.0474 13.3753 13.755C13.3866 12.6306 13.3923 11.5061 13.3753 10.3816C13.3696 9.93185 12.9493 9.64511 12.5006 9.73507ZM10.2174 12.8498C10.0697 12.6531 9.99023 12.4169 9.97887 12.1695C9.97319 11.3768 10.4105 10.8989 11.0353 10.9383C11.3022 10.9439 11.5521 11.0732 11.7112 11.2925C12.0292 11.7198 12.0292 12.4225 11.7112 12.8498C11.6544 12.9229 11.5919 12.9848 11.5237 13.0354C11.1091 13.339 10.5241 13.2547 10.2174 12.8498ZM18.2029 9.63949C16.8398 9.67885 15.88 10.7583 15.9254 12.2033C15.9027 13.6089 17.0784 14.6715 18.5608 14.5253C19.9182 14.3904 20.7985 13.384 20.7531 11.9615C20.7076 10.5559 19.6512 9.59451 18.2029 9.63949ZM17.5952 12.8555C17.4248 12.625 17.3396 12.3495 17.351 12.0683C17.351 11.3656 17.7826 10.9045 18.396 10.9383C18.663 10.9439 18.9129 11.0788 19.0719 11.2925C19.3957 11.7198 19.3957 12.4394 19.0662 12.8667C19.0151 12.9229 18.964 12.9792 18.9015 13.0241C18.4926 13.339 17.9076 13.2603 17.5952 12.8555ZM15.4269 11.9559C15.4262 11.6654 15.4256 11.3749 15.4256 11.0844C15.4256 10.7927 15.4262 10.5003 15.4269 10.2078V10.2071V10.2065C15.4281 9.61992 15.4294 9.03249 15.4256 8.44756C15.4256 7.99777 15.136 7.71665 14.7043 7.72228C14.284 7.72228 14.0057 8.00339 14 8.43631C13.9963 8.61227 13.9975 8.78573 13.9988 8.96003V8.96019V8.96035C13.9994 9.0477 14 9.13526 14 9.22344V13.6932C14 14.0474 14.2159 14.3454 14.4998 14.4185C14.568 14.4353 14.6418 14.441 14.71 14.441C15.1132 14.4297 15.4313 14.098 15.4256 13.6988C15.4294 13.1178 15.4281 12.5369 15.4269 11.9559ZM6.25529 13.0735H6.25491H6.25454C5.97473 13.0741 5.69083 13.0747 5.40111 13.0747C5.49198 12.951 5.54878 12.878 5.61125 12.8049C6.35528 11.8772 7.09931 10.9439 7.84334 10.0049C8.05916 9.72945 8.27499 9.45396 8.4113 9.13348C8.56465 8.76241 8.39994 8.4082 8.01373 8.27889C7.83766 8.23391 7.66159 8.21142 7.47984 8.21704C6.46887 8.21142 5.45222 8.21142 4.44125 8.21704C4.29926 8.21704 4.15727 8.23391 4.02096 8.26764C3.80514 8.31824 3.63475 8.49254 3.58363 8.70618C3.5098 9.02104 3.70858 9.34151 4.03232 9.4146C4.16863 9.44271 4.31062 9.45958 4.45261 9.45958C4.7593 9.46239 5.0674 9.46239 5.37551 9.46239C5.68364 9.46239 5.99177 9.46239 6.29848 9.4652C6.31643 9.46668 6.33517 9.46465 6.35407 9.46261C6.40695 9.45688 6.46111 9.45102 6.50295 9.52142C6.45184 9.58326 6.40074 9.65071 6.34963 9.71817L6.3496 9.71821C5.46926 10.8202 4.58892 11.9278 3.71426 13.0298C3.49844 13.3053 3.38485 13.6089 3.54388 13.9462C3.7029 14.2835 4.02664 14.351 4.35606 14.3679C4.54653 14.3799 4.73412 14.3776 4.92293 14.3753C4.99874 14.3744 5.07474 14.3735 5.1512 14.3735C5.38139 14.3735 5.61121 14.3739 5.84086 14.3742C6.52918 14.3753 7.2159 14.3763 7.90581 14.3679C8.39426 14.3623 8.65552 14.0643 8.60441 13.6201C8.55897 13.2659 8.31475 13.0804 7.86606 13.0747C7.33614 13.071 6.80374 13.0722 6.25569 13.0735H6.25565H6.25529Z",
          fill: "currentColor"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbar; },
/* harmony export */   "n": function() { return /* binding */ TOPBAR_HEIGHT; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);



const TOPBAR_HEIGHT = 42;
const Topbar = ({
  rightMenu = [],
  leftMenu = []
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledContainer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuWrapper, null, leftMenu.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    key: index
  }, item))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuWrapper, null, rightMenu.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    key: index
  }, item)))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => `
  @media print {
    display: none;
  }
  background-color: ${theme == null ? void 0 : theme.colors.primary500};
  height: ${TOPBAR_HEIGHT}px;
`);
const StyledContainer = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W)`
  display: flex;
  justify-content: space-between;
`;
const MenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: flex;
  .button-text {
    font-weight: 500;
  }
`;




/***/ }),

/***/ 94605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const isNotNullAndUndefined = (num) => {
  return num !== void 0 && num !== null;
};
const StyledBadge = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({
  theme,
  color,
  hidden,
  top,
  right,
  bottom,
  left,
  width,
  height,
  fontSize
}) => `
  display: block;
  position: absolute;
  z-index: 1;
  text-align: center;
  color: ${theme.colors.white};
  border-radius: 50%;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  padding: 0;
  opacity: ${hidden ? "0" : "1"};
  background-color: ${color ? color : theme.brand.primary};
  ${isNotNullAndUndefined(top) ? `top: ${top}px` : ""};
  ${isNotNullAndUndefined(bottom) ? `bottom: ${bottom}px` : ""};
  ${isNotNullAndUndefined(left) ? `left: ${left}px` : ""};
  ${isNotNullAndUndefined(right) ? `right: ${right}px` : ""};
  width: ${isNotNullAndUndefined(width) ? `${width}px` : "16px"};
  height: ${isNotNullAndUndefined(height) ? `${height}px` : "16px"};
  line-height: ${isNotNullAndUndefined(height) ? `${height}px` : "16px"};
  font-size: ${isNotNullAndUndefined(fontSize) ? `${fontSize}px` : "8px"};
`);
const Badge = (_a) => {
  var _b = _a, { text } = _b, rest = __objRest(_b, ["text"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBadge, __spreadValues({}, rest), text);
};




/***/ }),

/***/ 82074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CartHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86029);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49781);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94605);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34090);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34667);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92651);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 8px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







const IconCart = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .TekoLink */ .A)(_templateObject());
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .SvgIcon */ .l)(_templateObject1());
const CartHeader = (_param)=>{
    var { iconSize =20 , iconColor , badgeTop =0 , badgeRight =0 , badgeWidth =16 , clickCart , type ="outlined"  } = _param, rest = _objectWithoutProperties(_param, [
        "iconSize",
        "iconColor",
        "badgeTop",
        "badgeRight",
        "badgeWidth",
        "clickCart",
        "type"
    ]);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { totalCartItems  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_6__/* .useCartV2 */ .T)();
    const clickToCart = clickCart ? clickCart : ()=>{
        router.push("/cart").then(()=>window.scrollTo(0, 0));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(IconCart, _objectSpreadProps(_objectSpread({}, rest), {
        onClick: (e)=>{
            e.preventDefault();
            clickToCart();
        },
        href: "/cart",
        children: [
            type === "outlined" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
                name: "shopping-cart",
                size: iconSize,
                color: iconColor
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .ShoppingCartFilled */ .F, {
                size: iconSize,
                color: iconColor
            }),
            totalCartItems > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .Badge */ .C, {
                className: "cart-badge",
                width: badgeWidth,
                text: "".concat(totalCartItems),
                top: badgeTop,
                right: badgeRight
            })
        ]
    }));
};


/***/ }),

/***/ 43427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ HeaderIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84443);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28247);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58610);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23357);
/* harmony import */ var components_RegionPickerSuggestionPopover__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96199);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71323);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88813);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62204);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85104);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95517);
/* harmony import */ var _CartHeader__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82074);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  .cart-badge {\n    background-color: white;\n    color: black;\n    line-height: 12px;\n    height: 12px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










const Wrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].div((param)=>{
    let { isVisible , transitionDelay , theme  } = param;
    return "\n    max-width: ".concat(isVisible ? "180px" : "0px", ";\n    display: ").concat(isVisible ? "flex" : "none", ";\n    transition: max-width 0.2s ").concat(isVisible ? "ease-in" : "ease-out", ";\n    transition-delay: ").concat(isVisible ? transitionDelay : "0s", ";\n    overflow: hidden;\n    align-items: center;\n    column-gap: ").concat(theme.spacing.s16, ";\n    flex: 0 0 auto;\n  ");
});
const Anchor = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].a(_templateObject());
const IconWrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject1());
const HeaderIcon = (param)=>{
    let { isVisible =true , showRegionPopup , setShowRegionPopup , transitionDelay ="0s" , isDisplayContact =true , onlyShowLocationIcon , isShowCartIcon =false  } = param;
    const { contactLink , isDisplayMessenger , zaloContactLink , originalTerminal  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { locations , selectedLocation , showRegionPickerSuggestionPopover , onCloseRegionPickerSuggestionPopover ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useLocation */ .T)();
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useFeatureFlags */ .g)();
    const isShowRegionPickerIcon = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)() && flags.epic_ecom_284 ? locations.length > 1 : Array.isArray(originalTerminal) && (originalTerminal === null || originalTerminal === void 0 ? void 0 : originalTerminal.length) > 1;
    const regionIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(IconWrapper, {
        onClick: ()=>setShowRegionPopup(!showRegionPopup),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .LocationOutlined */ .f, {
                size: 30,
                color: "white"
            }),
            flags.epic_ecom_284 && !!selectedLocation && !onlyShowLocationIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Caption */ .YS, {
                level: 2,
                color: "white",
                line: 1,
                children: selectedLocation.locationName
            })
        ]
    });
    const regionPopper = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RegionPickerSuggestionPopover__WEBPACK_IMPORTED_MODULE_9__/* .RegionPickerSuggestionPopover */ .R, {
        isMobile: true,
        active: showRegionPickerSuggestionPopover,
        onClose: onCloseRegionPickerSuggestionPopover,
        children: regionIcon
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
            isVisible: isVisible,
            transitionDelay: transitionDelay,
            children: [
                isDisplayContact && contactLink && isDisplayMessenger && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, {
                    href: contactLink,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .getTrackingData */ .O5)({
                        isTrackContent: true,
                        regionName: "quickAction",
                        contentName: "fbMessengerIcon"
                    })), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .FacebookMessengerFilled */ ._, {
                            size: 30,
                            color: "#fff"
                        })
                    }))
                }),
                zaloContactLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, {
                    href: zaloContactLink,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .getTrackingData */ .O5)({
                        isTrackContent: true,
                        regionName: "quickAction",
                        contentName: "zaloMessengerIcon"
                    })), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .ZaloFilled */ .e, {
                            size: 28,
                            color: "#fff"
                        })
                    }))
                }),
                isShowRegionPickerIcon ? !onlyShowLocationIcon ? regionPopper : regionIcon : null,
                isShowCartIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CartIcon, {
                    iconSize: 24,
                    badgeWidth: 12,
                    badgeTop: -2,
                    iconColor: "#fff",
                    type: "filled"
                })
            ]
        })
    });
};
const CartIcon = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"])(_CartHeader__WEBPACK_IMPORTED_MODULE_13__/* .CartHeader */ .Q)(_templateObject2());


/***/ }),

/***/ 83803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HeaderRightItemSlot": function() { return /* binding */ HeaderRightItemSlot; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-b1561bfdfb/1/packages/auth-react/dist/context.es.js + 6 modules
var context_es = __webpack_require__(44254);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/LocationOutlined.es.js
var LocationOutlined_es = __webpack_require__(62204);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/OrderOutlined.es.js
var OrderOutlined_es = __webpack_require__(26463);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/ChecklistOutlined.es.js
var ChecklistOutlined_es = __webpack_require__(30221);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(88384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(36344);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(58519);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
// EXTERNAL MODULE: ./components/desktop/organisms/UserProfileHeader.tsx
var UserProfileHeader = __webpack_require__(83880);
// EXTERNAL MODULE: ./components/desktop/organisms/style.ts
var style = __webpack_require__(60862);
// EXTERNAL MODULE: ./components/RegionPickerSuggestionPopover/RegionPickerSuggestionPopover.tsx
var RegionPickerSuggestionPopover = __webpack_require__(96199);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ./contexts/LoyaltyProvider.tsx
var LoyaltyProvider = __webpack_require__(61105);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(23357);
// EXTERNAL MODULE: ./contexts/LocationProvider.tsx
var LocationProvider = __webpack_require__(58610);
// EXTERNAL MODULE: ./helpers/navigation-bar.tsx + 1 modules
var navigation_bar = __webpack_require__(31570);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(88813);
// EXTERNAL MODULE: ./hooks/useRegionPicker.tsx
var useRegionPicker = __webpack_require__(42816);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(34655);
// EXTERNAL MODULE: ./modules/cart/desktop/CartOverview.tsx
var CartOverview = __webpack_require__(36549);
// EXTERNAL MODULE: ./modules/notification/desktop/NotificationOverview.tsx
var NotificationOverview = __webpack_require__(68905);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx + 1 modules
var NavigationBar = __webpack_require__(90588);
;// CONCATENATED MODULE: ./modules/page-builder/slots/header-right-item/HeaderRightItemDesktop.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















const HeaderRightItemDesktop = (param)=>{
    let {} = param;
    const {} = (0,next_router.useRouter)();
    const { partner , tenant , notificationAppId ,  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    const { user , authService  } = (0,context_es/* useAuth */.a)();
    const { loyaltyMemberInfo  } = (0,LoyaltyProvider/* useLoyalty */.m)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const regionPickerProps = (0,useRegionPicker/* useRegionPicker */.j)();
    const region = regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.activeLocation;
    const { setShowed: showLocationPopup , selectedLocation , showRegionPickerSuggestionPopover , onCloseRegionPickerSuggestionPopover , enabled: locationPickerEnabled ,  } = (0,LocationProvider/* useLocation */.T)();
    const onLogin = ()=>authService.login(window.location.href);
    const router = (0,next_router.useRouter)();
    const profileLinks = (0,react.useMemo)(()=>{
        return (0,navigation_bar/* getNavItems */.r)({
            tenant,
            logged: !!(user === null || user === void 0 ? void 0 : user.userId),
            isLoyaltyMember: !!loyaltyMemberInfo,
            showNotificationItem: !!notificationAppId
        });
    }, [
        tenant,
        user
    ]);
    const RegionPickerIcon = (param)=>{
        let { locationName  } = param;
        const showRegionPickerModal = ()=>{
            if (flags.epic_ecom_284) {
                showLocationPopup(true);
            } else {
                regionPickerProps.onOpenPopup();
            }
        };
        // Don't show this icon on the server side
        if (!(0,helpers/* isServerless */.ep)()) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerSuggestionPopover/* RegionPickerSuggestionPopover */.R, {
            active: showRegionPickerSuggestionPopover,
            onClose: onCloseRegionPickerSuggestionPopover,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationBar/* NavItem */.LY, _objectSpreadProps(_objectSpread({
                onClick: showRegionPickerModal
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "location"
            })), {
                className: "att-home-page-delivery-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                        level: 2,
                        weight: "medium",
                        color: "textSecondary",
                        children: locationName
                    })
                ]
            }))
        });
    };
    const navItems = (0,react.useMemo)(()=>{
        var ref;
        const { order , login , cart , additional  } = NavigationBar/* defaultNavItemDisplayConfig */.dn;
        const navMenu = [];
        if (order) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, _objectSpreadProps(_objectSpread({
            className: "button",
            onClick: ()=>{
                if (!(user === null || user === void 0 ? void 0 : user.userId)) {
                    onLogin();
                } else {
                    router.push("/account/orders");
                }
            },
            style: (0,NavigationBar/* isVerticalNavItem */.fi)(tenant) ? {
                flexDirection: "column"
            } : {
                flexDirection: "row"
            }
        }, (0,helper_es/* getTrackingData */.O5)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "orderIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderOutlined_es/* OrderOutlined */.y, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "title",
                    children: (0,i18n.t)("Đơn h\xe0ng")
                })
            ]
        })));
        if (login) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileHeader/* UserProfileHeader */.F, {
            vertical: (0,NavigationBar/* isVerticalNavItem */.fi)(tenant),
            customProfile: !!partner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                href: "/account/orders",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                    className: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistOutlined_es/* ChecklistOutlined */.H, {
                            size: 36,
                            color: "textSecondary"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: (0,i18n.t)("Quản l\xfd đơn h\xe0ng")
                        })
                    ]
                })
            }) : undefined,
            profileLinks: profileLinks
        }));
        if (notificationAppId) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationOverview/* NotificationOverview */.C, {
            title: (0,NavigationBar/* isVerticalNavItem */.fi)(tenant)
        }));
        if (cart) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview/* CartOverview */.T, {
            showShippingFeeMiniCart: true,
            vertical: (0,NavigationBar/* isVerticalNavItem */.fi)(tenant)
        }));
        if (locationPickerEnabled) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.locationName
            }));
        } else if (region && (regionPickerProps === null || regionPickerProps === void 0 ? void 0 : (ref = regionPickerProps.terminals) === null || ref === void 0 ? void 0 : ref.length) > 1) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: region === null || region === void 0 ? void 0 : region.label
            }));
        }
        if (additional) navMenu.push(additional);
        return navMenu;
    }, [
        locationPickerEnabled,
        notificationAppId,
        partner,
        profileLinks,
        region,
        selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.locationName,
        tenant,
        user === null || user === void 0 ? void 0 : user.userId, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
        flexWrap: "nowrap",
        gap: "s16",
        align: "center",
        justify: "end",
        children: navItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                children: item
            }, index))
    });
};

// EXTERNAL MODULE: ./components/mobile/organisms/HeaderIcon.tsx
var HeaderIcon = __webpack_require__(43427);
;// CONCATENATED MODULE: ./modules/page-builder/slots/header-right-item/HeaderRightItemMobile.tsx




const HeaderRightItemMobile = (param)=>{
    let {} = param;
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const locationPickerProps = (0,LocationProvider/* useLocation */.T)();
    const { isShowed: isShowedLocationPopup , setShowed: showLocationPopup  } = locationPickerProps;
    const regionPickerProps = (0,useRegionPicker/* useRegionPicker */.j)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIcon/* HeaderIcon */.N, {
        isVisible: true,
        showRegionPopup: flags.epic_ecom_284 ? isShowedLocationPopup : regionPickerProps.showPopup,
        setShowRegionPopup: flags.epic_ecom_284 ? showLocationPopup : regionPickerProps.setShowPopup,
        isShowCartIcon: true
    });
};

;// CONCATENATED MODULE: ./modules/page-builder/slots/header-right-item/index.ts


const HeaderRightItemSlot = {
    desktop: HeaderRightItemDesktop,
    mobile: HeaderRightItemMobile
};


/***/ })

}]);